<h1 mat-dialog-title>{{ 'Esporta' | translate }}</h1>
<p>
  {{ 'Seleziona il formato con cui esportare l\'elemento.' | translate }}
</p>

<mat-dialog-content>
  <form [formGroup]="exportForm">
    <mat-form-field class="input-expanse">
      <mat-label>{{ 'Formato' | translate }}</mat-label>
      <mat-select formControlName="format">
        <mat-option
          *ngFor="let format of data.fileFormats"
          [value]="format">
          {{ format }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="input-expanse">
      <mat-label>{{ 'Layout' | translate }}</mat-label>
      <mat-select formControlName="layout">
        <mat-option
          *ngFor="let layout of layouts"
          [value]="layout.template">
          {{ layout.description }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="export-actions">
  <div>
    <button
      mat-button
      mat-raised-button
      type="button"
      (click)="closeHandler()">
      {{ 'Annulla' | translate }}
    </button>
    <button
      mat-button
      mat-raised-button
      color="primary"
      type="button"
      (click)="exportHandler()">
      {{ 'Esporta' | translate }}
    </button>
  </div>
</mat-dialog-actions>
